import {NgModule, Pipe, PipeTransform} from '@angular/core';


@Pipe({
    name: 'replaceTokens',
    standalone: false
})
export class ReplaceTokensPipe implements PipeTransform {

    transform(value: any, args: any): any {
        if (!args) {return value;}
		args.forEach((arg) => {
			var re = new RegExp(arg['key'], 'gi');
			var c = arg['key'];
			c = c.replace('[','').replace(']', '');
			value = value.replace(re, `<span>${arg['value']}</span>`);
		});
        return value;
    }
}

@NgModule({
    declarations: [ReplaceTokensPipe],
    exports: [ReplaceTokensPipe]
})
export class ReplaceTokensPipeModule {}